// Funds

import { Dispatch } from 'redux';

import { requestHandler } from '../../api';

export const getCompanyFunds = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/fund`,
    dispatch,
  });
  if (response) return response.data;
};

export const createFund = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/fund`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getFund = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/fund/${data.id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const deleteFund = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/fund/${data.id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const updateFund = async (dispatch: Dispatch, id: string, data: any) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/fund/${id}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const selectFundAsDefault = async (dispatch: Dispatch, id: string) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/fund/${id}/selectAsDefault`,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentsAssignedToFund = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/fund/${data.id}/documents`,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentForAssignation = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/fund/${data.id}/documents/available`,
    dispatch,
  });
  if (response) return response.data;
};

export const assignDocumentToFund = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/fund/${data.id}/documents/assign`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getFundPayments = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/fund/${data.id}/payments`,
    dispatch,
  });
  if (response) return response.data;
};

export const getAllFundPayments = async (dispatch: Dispatch, query: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/fund/payments?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const revertFundPayment = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/fund/payments/${data.id}/revert`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const checkRevertFundPayment = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/fund/payments/${data.id}/revert/check`,
    dispatch,
  });
  if (response) return response.data;
};

export const checkResellReversal = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/fund/${data.id}/revert/check`,
    dispatch,
  });
  if (response) return response.data;
};

export const revertResell = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/fund/${data.id}/revert`,
    dispatch,
  });
  if (response) return response.data;
};

export const createFundPayments = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/fund/payments`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const createFundInvoicesBuyBack = async (
  dispatch: Dispatch,
  data: {
    resellsForBuyback: { id: number; amount: number; buybackAt: Date }[];
  },
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/fund/buy-back`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const createFundOwnCollection = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/fund/own-collection`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const updateFundPayment = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/fund/${data.id}/payments/${data.paymentId}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getPaymentSuggestions = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/fund/${data.id}/payments/suggestions`,
    dispatch,
  });
  if (response) return response.data;
};

export const getFactoringResellsArrear = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/fund/documents/arrears`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const createFactoringResellPendingAccounts = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/fund/documents/pending-accounts`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const checkExistingCollections = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/fund/payments/check-collections`,
    data,
    dispatch,
  });
  if (response) return response.data;
};
